import { render, staticRenderFns } from "./ProjectUsers.vue?vue&type=template&id=03b8c5e4&scoped=true&"
import script from "./ProjectUsers.vue?vue&type=script&lang=js&"
export * from "./ProjectUsers.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUsers.vue?vue&type=style&index=0&id=03b8c5e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8c5e4",
  null
  
)

export default component.exports